export default "__VITE_ASSET__C8b5UQRY__"